<template>
  <div>
    <base-dialog
      @save-item="saveItem"
      dialogId="edit-card-model-dialog"
      max-width="100%"
      :open.sync="openDialog"
      :form-ref.sync="cardModelFormRef"
      :loading.sync="isLoading"
    >
      <template v-slot:[`dialog.title`]>
        <span>Modifier un modèle de carte</span>
      </template>
      <template v-slot:[`dialog.content`]>
        <v-container>
          <card-model-form
            :card-model-form.sync="cardModelForm"
            :rules="rules"
            :cardTypesChoice="cardTypesChoice"
            :card-origins-choice="cardOriginsChoice"
          ></card-model-form>
        </v-container>
      </template>
      <template v-slot:[`dialog.actions.save`]>Modifier</template>
    </base-dialog>
  </div>
</template>
<script>
import { toRefs, onMounted, computed } from "@vue/composition-api";
import { useCardModel } from "@/composables/card-model";
import CardModelForm from "@/components/CardModel/CardModelForm";
import BaseDialog from "@/components/General/BaseDialog.vue";

export default {
  components: {
    CardModelForm,
    BaseDialog,
  },
  props: {
    cardModel: Object,
    partner: Object,
    open: Boolean,
  },
  setup(props, { emit }) {
    /* Import des API */
    const { cardModelData, updateCardModel } = useCardModel();

    /* Variables */
    const {
      description,
      labelFrench,
      labelEnglish,
      cardOrigin,
      cardType,
      simultaneousSessionsNum,
      maxConnectionDuration,
      maxUsageDuration,
      idleTimeout,
    } = props.cardModel;

    /* Computed */
    const openDialog = computed({
      get: function () {
        return props.open;
      },
      set: function (value) {
        emit("update:open", value);
      },
    });

    /* Cycle de vie */
    onMounted(() => {
      console.log(props.cardModel);
      cardModelData.cardModelForm = {
        description,
        labelFrench,
        labelEnglish,
        cardOrigin: cardOrigin.id,
        cardType: cardType.id,
        simultaneousSessionsNum,
        maxConnectionDuration,
        maxUsageDuration,
        idleTimeout,
      };
    });

    /* Méthodes */
    const saveItem = async function () {
      await updateCardModel(props.cardModel, props.partner);
      openDialog.value = cardModelData.editCardModelDialog;
    };

    return {
      updateCardModel,
      ...toRefs(cardModelData),
      saveItem,
      openDialog,
    };
  },
};
</script>
